module.exports = __webpack_public_path__ + "img/boot.10cc9f20.svg";